$(document).ready(function() {

    const body = $('body');


    const modalDefault = (title, content, classes = '') => {
        return `
        <div class="modal-default js-modal ${classes}">
            <div class="modal__header">
                <div class="modal__title">${title}</div>
                <div class="modal__close js-modal-close"></div>
            </div>
            <div class="modal__content">
                ${content}
            </div>
        </div>
        `;
    }

    body.on('click', '.js-mobile-language-switcher', (e) => {
        const languageLinks = $('.page-footer .form-language');
        const languageTitle = languageLinks.closest('.pagebuilder-column').find('h5').text();
        body.addClass('is-modal-open-mobile');
        body.append(modalDefault(`<span class="icon-language-white"></span> ${languageTitle}`, languageLinks.prop('outerHTML'), 'modal-language-switcher'));
    });


    body.on('click', '.js-modal-close', (e) => {
        body.removeClass('is-modal-open-mobile');
        $(e.target).closest('.js-modal').remove();
    })
});
